/** Count available (sellable) serials on a product */
export const countAvailableSerials = (product) => {
  if (Array.isArray(product?.serials)) {
    return product.serials.filter(
      (s) => s && (s.status === 'available' || s.status === 'good')
    ).length;
  }
  return parseInt(product?.good_serials_count, 10) || 0;
};

/** Units in good stock that are not tied to a serial */
export const getNonSerialStock = (product) => {
  const good = parseInt(product?.good_quantity, 10) || 0;
  return Math.max(0, good - countAvailableSerials(product));
};

export const isMixedSerialProduct = (product) =>
  countAvailableSerials(product) > 0 && getNonSerialStock(product) > 0;
